import ErrorBoundary from '../components/ErrorBoundary';
import { MetadataInfo } from './metadataWidgets';
import { useAccountBottomBarStyles } from './AccountBottomBar.styles';

export default function AccountBottomBar({ leftSideContent }) {
  const { styles } = useAccountBottomBarStyles();
  return (
    <ErrorBoundary>
      <div className={styles.accountBottomBar}>
        {leftSideContent}
        <MetadataInfo canOpenChangelog />
      </div>
    </ErrorBoundary>
  );
}
